import { getProjectDisplayName } from "@/helper/models/project-display-helper"
import { type IProject } from "@/interfaces/api/project.interface"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { type RentalIntake } from "@/models/rental-intake.model"
import { ModelFactory } from "@/factories/model-factory"
import { BaseModelWithFiles, WithExtraFileBuckets } from "@/models/base-with-files.model"
import { ProjectGroup } from "@/models/project-group.model"

export class Project
  extends WithExtraFileBuckets("fileBucketServiceProviderAttachments")(BaseModelWithFiles)
  implements IProject
{
  public static className = "Project" // Used for socket communication.
  public static verboseName = "project"

  public static managedResolveFields = ["executor", "contact", "projectGroup"]

  id?: string

  executor: KnownBusinessEntityContact

  contact: KnownBusinessEntityContact

  projectGroup?: ProjectGroup | null

  name: string

  isActive: boolean

  descriptionPlanner?: string

  descriptionServiceProvider?: string

  rentalIntakes: RentalIntake[]

  constructor(project: IProject, managed = false) {
    super(project, managed)

    this.id = project.id
    this.projectGroup = ModelFactory.childModel(ProjectGroup, project.projectGroup, managed)
    this.executor = ModelFactory.childModel(KnownBusinessEntityContact, project.executor, managed)
    this.contact = ModelFactory.childModel(KnownBusinessEntityContact, project.contact, managed)

    this.name = project.name
    this.isActive = project.isActive ?? true
    this.descriptionPlanner = project.descriptionPlanner
    this.descriptionServiceProvider = project.descriptionServiceProvider

    this.rentalIntakes = []
  }

  public getDisplayText(): string {
    return `${getProjectDisplayName(this)} | ${this.executor.person.fullName} | ${this.executor.knownBusinessEntityName}`
  }

  public getDisplayArray(): [string, string, string] {
    return [
      getProjectDisplayName(this),
      `${this.executor.person.fullName}`,
      `${this.executor.knownBusinessEntityName}`
    ]
  }

  /** Label for @-mentions: project name plus financieel verantwoordelijke's business. */
  public getMentionLabel(): string {
    const businessName = this.executor?.knownBusinessEntityName?.trim()
    if (businessName && businessName !== "Onbekend") {
      return `${getProjectDisplayName(this)} | ${businessName}`
    }
    return getProjectDisplayName(this)
  }
}
